<template>
  <div class="floating">
    <div class="testowo">
      <!-- <p class="estimated-costs">Estimated cost</p>
      <p class="costs"><strong>$ 30</strong> / <small>day</small></p> -->
      <estimated-cost
        :details="details"
        v-if="details.TemplateType === 'VM'"
        class="mb-3"
      ></estimated-cost>
      <v-row align="center">
        <v-col lg="12" md="12" class="button-wrapper">
          <v-btn
            v-if="details.Status === 'running'"
            id="stop-btn-style"
            @click="onStopEnvironment(details.Id)"
            class="mb-2"
            :class="{ 'disabled-btn': loading }"
          >
            <!-- <div v-if="!loading">
              <v-icon left>fas fa-stop</v-icon>
              <span>Stop</span>
            </div>
            <v-icon center v-else>fas fa-spinner fa-spin</v-icon>Stop -->
            <v-icon small left v-if="!loading">fas fa-stop</v-icon>
            <v-icon small left v-else>fas fa-spinner fa-spin</v-icon>STOP
          </v-btn>

          <v-btn
            v-if="details.Status === 'stopped'"
            id="run-btn-style"
            @click="onStartEnvironment(details.Id)"
            :class="{ 'disabled-btn': loading }"
            class="mb-2"
            :disabled="
              duringRestoring ||
              details.TemplateStatus === 'pending' ||
              details.SnapshotStatus === 'pending'
            "
          >
            <!-- <div v-if="!loading">
              <v-icon left v-if="!loading">fas fa-play</v-icon>
              <span>Start</span>
            </div>
            <v-icon center v-else>fas fa-spinner fa-spin</v-icon>Start -->
            <v-icon small left v-if="!loading">fas fa-play</v-icon>
            <v-icon small left v-else>fas fa-spinner fa-spin</v-icon>start
          </v-btn>

          <v-chip
            outlined
            color="red"
            v-else-if="details.Status.toLowerCase().includes('failed')"
          >
            <v-avatar left> <v-icon>fas fa-exclamation</v-icon> </v-avatar>ERROR
          </v-chip>

          <!-- <v-chip outlined color="white" v-else-if="details.Status.toLowerCase() === 'during_restore'">
            <v-avatar left>
              <v-icon>fas fa-spinner fa-spin</v-icon>
            </v-avatar>RESTORING
          </v-chip> -->

          <v-btn
            id="run-btn-style"
            class="stopping-btn-style disabled-btn"
            v-if="
              details.Status.toLowerCase().includes('pending') ||
              details.Status.toLowerCase().includes('create') ||
              details.Status.toLowerCase().includes('starting') ||
              details.Status.toLowerCase().includes('stopping')
            "
          >
            <div
              v-if="
                details.Status.toLowerCase() === 'pending' ||
                details.Status.toLowerCase().includes('create') ||
                details.Status.toLowerCase().includes('starting')
              "
            >
              <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>STARTING
            </div>
            <div v-else>
              <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>STOPPING
            </div>
          </v-btn>

          <v-btn
            v-if="details.Status.toLowerCase() === 'during_restore'"
            id="run-btn-style"
            class="disabled-btn during-action-btn-style"
          >
            <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>RESTORING
          </v-btn>

          <!-- <v-chip outlined color="white" v-else>
              <v-avatar left>
                <v-icon>fas fa-spinner fa-spin</v-icon>
              </v-avatar>
              {{ details.Status }}
          </v-chip>-->

          <br />

          <span
            v-if="
              details.Status === 'running' ||
              details.Status === 'pending' ||
              details.Status === 'stopped'
            "
            class="status"
            >{{ templateSnapshotStatus() }} {{ details.Status }}
          </span>
        </v-col>
      </v-row>
    </div>
    <!-- RDS returns null value as true -->
    <div
      :class="!details.ConnectedId ? 'remote-environment' : 'pt-8 pb-8'"
      v-if="details.TemplateType === 'VM'"
    >
      <div>
        <h3 class="title-r">Remote Access</h3>
      </div>
      <hr :class="!details.ConnectedId ? 'underscore' : 'underscore mb-4'" />
      <div class="data">
        <!-- <small>Download file (Linux)</small> -->

        <!-- for Linux based environments - open dialog with ssh command -->
        <h2
          @click="openConnectDialog()"
          class="text-uppercase connect"
          :class="{ disabled: details.Status !== 'running' }"
          v-if="details.OS === 'Linux' || details.ConnectedId && details.OS === 'Windows'"
        >
          Connect
          <v-icon right id="icon-style">far fa-plug</v-icon>
        </h2>

        <!-- for windows - download rdp file -->
        <div v-else>
          <a
            :download="`${details.EnvironmentName}.rdp`"
            :href="`data:application/octet-stream;charset=utf-8;base64,${rdp}`"
            :class="{ disabled: details.Status !== 'running' }"
            class="text-uppercase connect"
            @click="addToTheWhitelist()"
          >
            Connect
            <v-icon right id="icon-style">far fa-plug</v-icon>
          </a>
        </div>

        <!-- <p class="creds" id="login">Login: <strong>ec2-user</strong></p> -->
        <v-btn
          v-if="details.AccessLevel || details.OwnerSub == sub"
          text
          class="text-none"
          @click="openWhitelistDialog()"
          >Settings</v-btn
        >
        <div v-if="details.OS === 'Windows' && !details.ConnectedId">
          <p class="creds" id="login">
            Login:
            <strong>{{ remoteEnvLogin }}</strong>
          </p>
          <p class="creds" id="password">
            Password:
            <strong id="rdp-password" @click="copyPassword('rdp')">{{
              remoteEnvPassword
            }}</strong>
            <v-icon
              right
              small
              class="copy-icon"
              @click="togglePassword('rdp')"
              :class="
                hiddenRemoteEnvPassword ? 'far fa-eye' : 'fas fa-eye-slash'
              "
            ></v-icon>
          </p>
        </div>
        <!-- <p class="creds" id="password">Password: 
          <strong id="remote-environment" @click="copyPassword">{{ remoteEnvPassword }}</strong>
          <v-icon right small class="copy-icon" @click="togglePassword" :class="hiddenRemoteEnvPassword ? 'far fa-eye' : 'fas fa-eye-slash'"></v-icon>
        </p>-->
      </div>
    </div>

    <div class="remote-environment" v-if="!details.ConnectedId">
      <div class="web-app-title">
        <h3 class="title-r">Web application</h3>
        <hr class="underscore" />
      </div>
      <div class="data">
        <h2>
          <a
            :href="'http://' + details.FQDN"
            target="_blank"
            :class="{ disabled: details.Status !== 'running' }"
            >link</a
          >
        </h2>
        <div v-if="details.ApplicationLogin">
          <p class="creds" id="login">
            Login:
            <strong>{{ details.ApplicationLogin }}</strong>
          </p>
          <p class="creds" id="password">
            Password:
            <strong id="web-app-environment" @click="copyPassword('web')">{{
              webAppPassword
            }}</strong>
            <v-icon
              right
              small
              class="copy-icon"
              @click="togglePassword('web')"
              :class="hiddenWebPassword ? 'far fa-eye' : 'fas fa-eye-slash'"
            ></v-icon>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EstimatedCost from "./Tabs/EstimatedCost";

export default {
  data() {
    return {
      loading: false,
      rdp: "",
    };
  },
  components: {
    EstimatedCost,
  },
  props: [
    "remoteEnvPassword",
    "webAppPassword",
    "hiddenRemoteEnvPassword",
    "hiddenWebPassword",
    "remoteEnvLogin",
    "sub",
    "details",
  ],
  computed: mapGetters(["duringRestoring"]),
  methods: {
    ...mapActions([
      "stopEnvironment",
      "startEnvironment",
      "stopConnectedEnvironment",
      "startConnectedEnvironment",
      "getDetails",
      "getConnectedEnvironmentDetails",
      "addWhitelistedIP",
    ]),
    togglePassword(which) {
      this.$emit("togglePassword", which);
    },
    copyPassword(which) {
      this.$emit("copyPassword", which);
    },
    async onStopEnvironment(id) {
      this.loading = true;

      if (this.details.ConnectedId) {
        const data = {
          connectedEnvId: this.details.ConnectedId,
        };
        await this.stopConnectedEnvironment(data);
        await this.getConnectedEnvironmentDetails(this.details.ConnectedId);
      } else {
        const data = {
          environmentId: id,
        };
        await this.stopEnvironment(data);
        await this.getDetails(id);
      }
      this.loading = false;
      this.$emit("statusChange");
    },
    async onStartEnvironment(id) {
      this.loading = true;

      if (this.details.ConnectedId) {
        const data = {
          connectedEnvId: this.details.ConnectedId,
        };
        await this.startConnectedEnvironment(data);
        await this.getConnectedEnvironmentDetails(this.details.ConnectedId);
      } else {
        const data = {
          environmentId: id,
        };
        await this.startEnvironment(data);
        await this.getDetails(id);
      }
      this.loading = false;
      this.$emit("statusChange");
    },
    openConnectDialog() {
      this.$emit("openConnectDialog");
    },
    openWhitelistDialog() {
      this.$emit("openWhitelistDialog");
    },
    encodeRDPFile() {
      const { FQDN } = this.details;
      
      let rdp = `
      auto connect:i:1
      full address:s:rdp.${FQDN}
      username:s:Administrator
      `;
      
      const encoded = window.btoa(rdp);

      this.rdp = encoded;
    },
    async addToTheWhitelist() {
      const id = this.$route.params.id;
      await this.addWhitelistedIP(id);
    },
    templateSnapshotStatus() {
      const { TemplateStatus, SnapshotStatus } = this.details;

      if (TemplateStatus === "pending") {
        return "creating a template /";
      }

      if (SnapshotStatus === "pending") {
        return "creating a snapshot /";
      }
    },
  },
  created() {
    const { OS } = this.details;

    if (OS === "Windows") {
      this.encodeRDPFile();

      console.log(this.rdp);
    }
  },
};
</script>

<style scoped>
.right-side .floating .testowo {
  background: url("../../../assets/details-background.png") no-repeat;
  width: 100%;
  height: 215px;
  background-position: 100%;
  padding-top: 45px;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}

.testowo {
  height: 250px !important;
}

.details .estimated-costs,
.costs {
  color: #fff;
  text-align: center;
}

.details .estimated-costs {
  font-size: 1.1em;
}

.details .costs {
  font-size: 1.8em;
}

.details .button-wrapper {
  text-align: center;
}

.details .remote-environment {
  padding-bottom: 20px;
}

.details .remote-environment:nth-child(2) {
  border-bottom: 1px solid #eeeeee;
}

.details .remote-environment .title-r {
  margin-top: 40px;
  font-size: 1.1em;
}

.details .remote-environment .copy-icon {
  margin-left: 5px;
}

/* .details .remote-environment .title-r:before {
  position: absolute;
  bottom: -5px;
  content: '';
  width: 50px;
  border-bottom: 2px solid #D0398B;
  text-align: center;
  left: 50%;
  margin-left: -25px;
} */
.details .remote-environment .data {
  margin-top: 20px;
  /* padding-top: 40px; */
}

.details .remote-environment .data .connect {
  cursor: pointer;
  font-weight: bold;
  font-size: 1.3em;
  text-decoration: none;
}

.details .remote-environment .data h2 {
  color: #6db42c;
  font-size: 1.3em;
}

.details .remote-environment .data #icon-style {
  padding-bottom: 6px;
}

.details .remote-environment .data .creds {
  font-size: 0.9em;
  color: #888888;
}

.details .remote-environment .data #login {
  margin-top: 20px;
  margin-bottom: 5px;
}

.details .remote-environment strong {
  color: #000;
}

.details .remote-environment a {
  color: #6db42c;
}

.underscore {
  background-color: #d0398b;
  border: 0.1vh solid #d0398b;
  border-radius: 0.1vh;
  width: 3vw;
  margin-top: 1vh;
  margin-left: 6.8vw;
}

.disabled-btn {
  pointer-events: none;
}

.disabled {
  pointer-events: none;
  cursor: default;
  color: grey !important;
}

.stopping-btn-style {
  background-color: #cb2536 !important;
}

.disabled #icon-style {
  color: grey;
}

#password {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  text-align: center;
  margin: 0 auto;
}

.during-action-btn-style {
  background-color: #f3d526 !important;
}

.status {
  margin-left: 10px;
  top: 20px;
  color: white;
}
</style>
